import { DatastoreInterface } from '@freelancer/datastore/core';
import { Skill } from './skills.model';
import { SkillsCollection } from './skills.types';

export async function createSkills(datastore: DatastoreInterface) {
  const objects = generateSkillObjects();
  await Promise.all(
    objects.map(object =>
      datastore.createRawDocument<SkillsCollection>('skills', object),
    ),
  );
  return objects;
}

function generateSkillObjects(): ReadonlyArray<Skill> {
  return [
    phpSkill,
    {
      id: 13,
      name: 'Python',
      category: { id: 1, name: 'Websites, IT & Software' },
      local: false,
      seoUrl: 'python',
      activeProjectCount: 6,
    },
    websiteDesignSkill,
    {
      id: 22,
      name: 'Translation',
      category: { id: 2, name: 'Writing & Content' },
      local: false,
      seoUrl: 'translation',
      activeProjectCount: 13,
    },
    photographySkill,
    logoDesignSkill,
    {
      id: 36,
      name: 'Data Processing',
      category: { id: 4, name: 'Data Entry & Admin' },
      local: false,
      seoUrl: 'data-processing',
      activeProjectCount: 6,
    },
    {
      id: 39,
      name: 'Data Entry',
      category: { id: 4, name: 'Data Entry & Admin' },
      local: false,
      seoUrl: 'data-entry',
      activeProjectCount: 45,
    },
  ];
}

export const phpSkill = {
  id: 3,
  name: 'PHP',
  category: {
    id: 1,
    name: 'Websites, IT & Software',
  },
  local: false,
  seoUrl: 'php',
  activeProjectCount: 467,
};

export const websiteDesignSkill = {
  id: 17,
  name: 'Website Design',
  category: { id: 3, name: 'Design, Media & Architecture' },
  local: false,
  seoUrl: 'website-design',
  activeProjectCount: 619,
};

export const graphicDesignSkill = {
  id: 20,
  name: 'Graphic Design',
  category: { id: 3, name: 'Design, Media & Architecture' },
  local: false,
  seoUrl: 'graphic-design',
  activeProjectCount: 290,
};

export const photographySkill = {
  id: 27,
  name: 'Photography',
  category: { id: 3, name: 'Design, Media & Architecture' },
  local: true,
  seoUrl: 'photography',
  activeProjectCount: 63,
};

export const logoDesignSkill = {
  id: 32,
  name: 'Logo Design',
  category: { id: 3, name: 'Design, Media & Architecture' },
  local: false,
  seoUrl: 'logo-design',
  activeProjectCount: 102,
};
